export default ({
  sightMapType, 
  category, 
  path, 
  route
}) => ({
  path: path,
  component: { 
    name: 'sight-map-wrapper',
    render(h) { 
      return h({
        template: '<router-view />',
        props: {
          sightMapType: {
            type: String,
            default: ''
          },
          category: {
            type: String,
            default: ''
          }
        }
      }, { 
        props: { sightMapType, category } 
      })
    } 
  },
  children: [ route ]
})